import React from 'react';
import { Link, Drawer, Select } from '@material-ui/core';
import useStyles from './styles';
import './HeaderStyles.css';

export default function Header() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isOpenMenu, setIsOpenMenu] = React.useState(false);
  const [isVisit, setIsVisit] = React.useState(false);
  const [isHover, setIsHover] = React.useState(false);
  const [activeCountry, setActiveCountry] = React.useState('');

  const handleDrawer = isOpenMenu => {
    setIsOpenMenu(isOpenMenu);
  };

  const visitCountry = isVisit => {
    setIsVisit(isVisit);
  };

  const toggleHover = (isHover, country) => {
    setIsHover(isHover);
    setActiveCountry(country);
  };

  const openChatHead = event => {
    window['chatNowButtonToggle'](event);
  };

  return (
    <div className="nxtg-header-wrapper">
      <div className="nxtg-hamburger-icon" onClick={() => handleDrawer(true)}>
        <div className="nxtg-inner-lines">
          <div className="nxtg-line1"></div>
          <div className="nxtg-line2"></div>
          <div className="nxtg-line3"></div>
        </div>
      </div>
      <Drawer
        anchor={'left'}
        open={isOpenMenu}
        onClose={() => {
          handleDrawer(false);
        }}
        className="nxtg-hamburger-open"
      >
        {' '}
        <div className="nxtg-header-wrapper">
          <div
            className="nxtg-hamburger-icon"
            onClick={() => handleDrawer(false)}
          >
            <div className="nxtg-inner-lines">
              <div className="nxtg-line1"></div>
              <div className="nxtg-line2"></div>
              <div className="nxtg-line3"></div>
            </div>
          </div>
          <div className="nxtg-left-content">
            <div className="nxtg-header-logo">
              <a
                href="https://www.fwd.com.ph/"
                type="svg+xml"
                aria-label="FWD Logo"
              >
                <svg
                  viewBox="0 0 105 36"
                  width="100%"
                  height="100%"
                  focusable="false"
                >
                  <path
                    d=" m85.0647368 16.8813014c.2339474.2394642.3647369.553646.3647369.8886508 0
              .332555-.1307895.6510239-.3647369.8898756l-6.2158772
              6.1452248c-.2468421.2388517-.5728947.3680766-.9001754.3680766-.1633333
              0-.3291228-.0275598-.4881579-.0967656-.472807-.1947559-.7810526-.6516363-.7810526-1.1593492v-12.2922871c0-.5107751.3082456-.9664306.7810526-1.1648613.4771053-.1929186
              1.0229825-.0839043 1.3883333.2737608z"
                    fill="#e87722"
                  />
                  <path
                    d="m46.1005263.88926316c-.7386842.59467942-1.2642982 1.29898564-1.5903509 2.12026794-.3242105.81699522-.6821929 2.00390431-1.1009649 3.56991388l-.3278947 1.22855502-4.0403509 15.8530144-4.708421-20.27789478c-.4003509-1.93776077-1.4890351-3.13385646-4.1846492-3.13385646h-28.77491224c-1.32263158 0-1.36929825 1.39330143-1.37298246 1.4049378v32.86047844s.02210526.6987943.6981579.6987943h2.67350877c1.92008772 0 4.37438596-1.2346794 4.37438596-4.6398469v-10.0103349h10.07631577c3.8432456 0 4.7790351-2.7363828 4.7790351-4.2925933v-.5781436c0-.552421-.1872807-.8874258-.8553509-.8874258h-13.99999997v-8.29182776h19.79280697l5.9727193 22.93833496c.1829825.6865454 1.2280702 4.3164784 1.2280702 4.3164784.402193 1.2726508.3579825 1.4576077 1.4448246 1.4576077h2.4199123c2.9731579 0 3.9998245-1.8269091 4.5248245-3.1160957.2640351-.6987943.4513158-1.0062392.8756141-2.5820479l5.2659649-19.77385641 5.5699123 19.67525361c.1811403.6871579 1.1531578 4.331177 1.1531578 4.331177.400965 1.2683636.3604386 1.4631196 1.4478948 1.4631196h2.4174561c2.975 0 4.0035088-1.8287464 4.5291228-3.1258947.2572807-.6987943.5170176-1.3669665.943772-2.9391005l5.4753508-22.62537798h16.9547369c1.4577193 0 2.6311403.12677512 3.6878947.44585646 1.3668421.40972249 2.5826316 1.43188517 3.5970176 3.03157892.9824561 1.5684594 1.5442982 4.3146412 1.5700877 7.725933-.0018421 3.8448996-1.155 7.2580288-3.2967544 9.1026986-.4771053.429933-1.0371053.7631005-1.7008772 1.0062392-.6766667.2486508-1.330614.4054354-1.9507895.4679043-.6680701.0698182-1.5522807.2045551-2.7152631.2143541h-.016579l-3.6977193.0061244h-5.3120175l-.0264035-.0061244c-1.1488597 0-1.1850877.6651101-1.1850877.9517321v1.3755406c0 2.0014546 1.6566666 4.3023924 4.9835087 4.3023924h.1148246l6.4535088-.0036747c1.6425438-.0165358 3.116228-.1365741 4.4370175-.3613397 1.3281579-.2308899 2.5783333-.6106028 3.7419298-1.1624115 1.1635965-.5444593 2.2381579-1.2671387 3.2163158-2.1588516 1.236053-1.1562871 2.244912-2.4632345 3.031491-3.9245168.777369-1.4618947 1.350877-3.0903732 1.711316-4.8829856.340175-1.6927847.509035-2.8974546.509035-4.9050335v-.0422584c-.056491-6.5010526-1.982719-11.1225263-5.8210525-14.34886123-1.4718421-1.26713875-3.1303509-2.13435406-4.9540351-2.58817225-1.6947368-.42564593-3.6958772-.63448803-5.9825439-.63448803h-20.5419298c-1.1273684.0122488-2.8165789.59222966-3.4662281 3.23858373l-4.4566666 20.14744498-4.7366667-15.79850718v.01163636l-.3180702-1.1642488c-.4568421-1.68421053-.8252631-2.89316747-1.0991228-3.62380862-.2757017-.72880382-.7607894-1.40371292-1.4736842-2.02778947-.7024561-.61856459-1.6965789-.92784689-2.9731579-.92784689-1.2661403 0-2.258421.29519617-2.9909649.88926316"
                    fill="#183028"
                  />
                </svg>
              </a>
            </div>
            <div className="nxtg-header-links-wrapper">
              <div className="nxtg-header-dialoag-wrapper">
                <div className="nxtg-header-links-primary-secondary">
                  <div className="nxtg-primary-link">
                    <ul>
                      {/* Products */}
                      <li>
                        <a href="https://www.fwd.com.ph/products/">
                          <span className="nxtg-primary-link-icon">
                            <svg
                              focusable="false"
                              viewBox="0 0 48 48"
                              aria-hidden="true"
                              role="presentation"
                            >
                              <g>
                                <path d="m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"></path>
                                <path
                                  d="m15.9982667 2.66653333.1746666.00733334c.1776-.01066667.2818134.01365333.3805654.04770133l.0741013.02696533-.01.028c1.2122182.2808 4.0252641 1.21195637 11.4090674 3.81941035l.4149326.14658965.726.25666667.1406667.75733333c.016.088.228 1.27466667.2086666 3.08133337-.0135333 1.3552666-1.6069007 2.0452089-2.6079757 1.1942314l-.1013576-.0935648c.0793333-1.264.0306667-2.30599997-.0293333-2.95466663-4.5666667-1.608-9.4646667-3.28133334-10.6953334-3.61266667-1.232.332-6.1353333 2.00666667-10.7033333 3.61533333-.28933333 2.84199997-.466 12.91533337 10.7033333 17.54399997 1.1126667-.4613333 2.1473334-.994 3.0966667-1.59.753125-.4725 1.7130859-.4235156 2.3827515.1376148l.1299152.1190519.7186666.718c0 .0046667-.0006666.006-.0006666.01-1.5606154 1.2344615-3.3831006 2.2814675-5.4197397 3.1148002l-.5135937.2038665-.2313333.0893333h-.3206667l-.2366666-.0893333c-15.36546003-5.91426-12.91139523-21.02708523-12.83296215-21.47817636l.00162878-.00915701.14066667-.75733333.726-.25666667c7.5541091-2.66989091 10.4824621-3.64448529 11.7549887-3.94972439l.0690113-.01627561-.01-.028c.1002667-.0368.1890133-.06976.3341653-.07566933l.1205014.00100267zm8.9835333 9.87906667v3.9993333h4v.6666667c0 1.0544545-.8157893 1.9181736-1.8507256 1.9945148l-.1492744.0054852h-2v2.0006667c0 1.0544545-.8157893 1.9181735-1.8507256 1.9945148l-.1492744.0054852h-.6666667v-4.0006667h-4v-.6666667c0-1.0538181.8157893-1.9181157 1.8507256-1.9945109l.1492744-.0054891h2v-1.9993333c0-1.0544545.8157893-1.9181736 1.8507256-1.9945148l.1492744-.0054852zm-9.3335333 2.1191333v.6666667c0 1.104-.8953334 2-2 2h-4.70200003c-.368 0-.66666667-.298-.66666667-.6666667v-1.3333333c0-.3686667.29866667-.6666667.66666667-.6666667zm4.0002-4v.6666667c0 1.0538182-.8157893 1.9181157-1.8507256 1.9945109l-.1492744.0054891h-8.89933337c-.33454545 0-.61179063-.246281-.65943401-.5680441l-.00723265-.0986226v-1.3333333c0-.3351515.24683195-.6119008.56819434-.659449l.09847232-.0072177z"
                                  transform="translate(8 8)"
                                ></path>
                              </g>
                            </svg>
                          </span>
                          Products
                        </a>
                      </li>

                      {/* Claims */}
                      <li>
                        <a href="https://www.fwd.com.ph/claims/">
                          <span className="nxtg-primary-link-icon">
                            <svg
                              focusable="false"
                              viewBox="0 0 48 48"
                              aria-hidden="true"
                              role="presentation"
                            >
                              <g>
                                <path d="m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"></path>
                                <path
                                  d="m18.6689333 20.6287333v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.962v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0 4v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.37333333.3-.66666667.6666667-.66666667zm-6.6686666 3.99999997v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0 4v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.37333333.3-.66666667.66666667-.66666667zm14.6666666 1.33333337h-4v-2.00000003c0-1.10733334.9-2 2-2 1.1066667 0 2 .89266666 2 2zm-6.6666666-2.00000003v18.00000003h-14.6666667v-18.00000003c0-1.10733334.9-2 2-2h13.12c-.2866667.60666666-.4533333 1.28-.4533333 2zm4.6666666-4.66666667h-17.3333333c-2.57333333 0-4.66666667 2.09266667-4.66666667 4.66666667v20.66666663h19.99999997v-16h5.3333334c.7393333 0 1.3333333-.6 1.3333333-1.3333333v-3.33333333c0-2.574-2.094-4.66666667-4.6666667-4.66666667z"
                                  transform="translate(8 8)"
                                ></path>
                              </g>
                            </svg>
                          </span>
                          Claims
                        </a>
                      </li>
                      {/* Support */}
                      <li>
                        <a href="https://www.fwd.com.ph/support">
                          <span className="nxtg-primary-link-icon">
                            <svg
                              focusable="false"
                              viewBox="0 0 48 48"
                              aria-hidden="true"
                              role="presentation"
                            >
                              <g>
                                <path d="m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"></path>
                                <path
                                  d="m18.6689333 20.6287333v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.962v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0 4v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.37333333.3-.66666667.6666667-.66666667zm-6.6686666 3.99999997v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0 4v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.37333333.3-.66666667.66666667-.66666667zm14.6666666 1.33333337h-4v-2.00000003c0-1.10733334.9-2 2-2 1.1066667 0 2 .89266666 2 2zm-6.6666666-2.00000003v18.00000003h-14.6666667v-18.00000003c0-1.10733334.9-2 2-2h13.12c-.2866667.60666666-.4533333 1.28-.4533333 2zm4.6666666-4.66666667h-17.3333333c-2.57333333 0-4.66666667 2.09266667-4.66666667 4.66666667v20.66666663h19.99999997v-16h5.3333334c.7393333 0 1.3333333-.6 1.3333333-1.3333333v-3.33333333c0-2.574-2.094-4.66666667-4.6666667-4.66666667z"
                                  transform="translate(8 8)"
                                ></path>
                              </g>
                            </svg>
                          </span>
                          Support
                        </a>
                      </li>
                      {/* Blog */}
                      <li>
                        <a href="https://www.fwd.com.ph/blog">
                          <span className="nxtg-primary-link-icon">
                            <svg
                              focusable="false"
                              viewBox="0 0 48 48"
                              aria-hidden="true"
                              role="presentation"
                            >
                              <g>
                                <path d="m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"></path>
                                <path
                                  d="m18.6689333 20.6287333v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.962v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0 4v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.37333333.3-.66666667.6666667-.66666667zm-6.6686666 3.99999997v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0 4v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.37333333.3-.66666667.66666667-.66666667zm14.6666666 1.33333337h-4v-2.00000003c0-1.10733334.9-2 2-2 1.1066667 0 2 .89266666 2 2zm-6.6666666-2.00000003v18.00000003h-14.6666667v-18.00000003c0-1.10733334.9-2 2-2h13.12c-.2866667.60666666-.4533333 1.28-.4533333 2zm4.6666666-4.66666667h-17.3333333c-2.57333333 0-4.66666667 2.09266667-4.66666667 4.66666667v20.66666663h19.99999997v-16h5.3333334c.7393333 0 1.3333333-.6 1.3333333-1.3333333v-3.33333333c0-2.574-2.094-4.66666667-4.6666667-4.66666667z"
                                  transform="translate(8 8)"
                                ></path>
                              </g>
                            </svg>
                          </span>
                          Blog
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="nxtg-secondary-link">
                    <ul>
                      <li>
                        <a href="https://www.fwd.com.ph/about/">About us</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="nxtg-header-country-wrapper-mobile">
                  <div className="nxtg-country-wrapper">
                    <span className="nxtg-country-label">Visit FWD</span>
                    <div className="nxtg-dropdown-wrapper nxtg-dropmenu-country">
                      <div
                        className="nxtg-country-dropmenu-container"
                        onClick={() => visitCountry(!isVisit)}
                      >
                        <span>Philippines</span>
                        <svg
                          focusable="false"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <path
                              d="M12.5855,21.2426 L23.1715,10.6576 L33.7575,21.2426 L34.4645,20.5356 C35.6365,19.3646 35.6365,17.4646 34.4645,16.2936 L23.1715,4.9996 L11.8785,16.2936 C10.7065,17.4646 10.7065,19.3646 11.8785,20.5356 L12.5855,21.2426 Z M34.4645,27.1216 C35.6365,28.2926 35.6365,30.1926 34.4645,31.3636 L23.1715,42.6576 L11.8785,31.3636 C10.7065,30.1926 10.7065,28.2926 11.8785,27.1216 L12.5855,26.4146 L23.1715,36.9996 L33.7575,26.4146 L34.4645,27.1216 Z"
                              fill="#E87722"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      {isVisit && (
                        <div className={classes.whiteBG}>
                          <Select
                            open={isVisit}
                            onClose={() => {
                              visitCountry(!isVisit);
                            }}
                          >
                            <Link
                              href="https://www.fwd.com.ph/"
                              onMouseEnter={() => {
                                toggleHover(true, 'FWD');
                              }}
                              onMouseLeave={() => {
                                toggleHover(false, 'FWD');
                              }}
                              className={
                                isHover && activeCountry === 'FWD'
                                  ? classes.listItemHovered
                                  : classes.listItem
                              }
                            >
                              FWD Group
                            </Link>
                            <Link
                              href="https://www.fwd.com.hk/"
                              onMouseEnter={() => {
                                toggleHover(true, 'HK');
                              }}
                              onMouseLeave={() => {
                                toggleHover(false, 'HK');
                              }}
                              className={
                                isHover && activeCountry === 'HK'
                                  ? classes.listItemHovered
                                  : classes.listItem
                              }
                            >
                              Hong Kong
                            </Link>
                            <Link
                              href="https://www.fwd.co.id/"
                              onMouseEnter={() => {
                                toggleHover(true, 'ID');
                              }}
                              onMouseLeave={() => {
                                toggleHover(false, 'ID');
                              }}
                              className={
                                isHover && activeCountry === 'ID'
                                  ? classes.listItemHovered
                                  : classes.listItem
                              }
                            >
                              Indonesia
                            </Link>
                            <Link
                              href="https://www.fwdfujilife.co.jp/"
                              onMouseEnter={() => {
                                toggleHover(true, 'JP');
                              }}
                              onMouseLeave={() => {
                                toggleHover(false, 'JP');
                              }}
                              className={
                                isHover && activeCountry === 'JP'
                                  ? classes.listItemHovered
                                  : classes.listItem
                              }
                            >
                              Japan
                            </Link>
                            <Link
                              href="https://www.fwd.com.ph/"
                              onMouseEnter={() => {
                                toggleHover(true, 'PH');
                              }}
                              onMouseLeave={() => {
                                toggleHover(false, 'PH');
                              }}
                              className={
                                isHover && activeCountry === 'PH'
                                  ? classes.listItemHovered
                                  : classes.listItem
                              }
                            >
                              <span>Philippines</span>
                              <span>
                                <svg
                                  focusable="false"
                                  viewBox="0 0 48 48"
                                  aria-hidden="true"
                                  role="presentation"
                                >
                                  <g
                                    stroke="none"
                                    stroke-width="1"
                                    fill="none"
                                    fill-rule="evenodd"
                                  >
                                    <path
                                      d="M12.5855,21.2426 L23.1715,10.6576 L33.7575,21.2426 L34.4645,20.5356 C35.6365,19.3646 35.6365,17.4646 34.4645,16.2936 L23.1715,4.9996 L11.8785,16.2936 C10.7065,17.4646 10.7065,19.3646 11.8785,20.5356 L12.5855,21.2426 Z M34.4645,27.1216 C35.6365,28.2926 35.6365,30.1926 34.4645,31.3636 L23.1715,42.6576 L11.8785,31.3636 C10.7065,30.1926 10.7065,28.2926 11.8785,27.1216 L12.5855,26.4146 L23.1715,36.9996 L33.7575,26.4146 L34.4645,27.1216 Z"
                                      fill="#E87722"
                                    ></path>
                                  </g>
                                </svg>
                              </span>
                              <svg
                                focusable="false"
                                viewBox="0 0 48 48"
                                aria-hidden="true"
                                role="presentation"
                                height="1.5rem"
                                className={classes.marginLeft}
                              >
                                <g
                                  stroke="none"
                                  stroke-width="1"
                                  fill="none"
                                  fill-rule="evenodd"
                                >
                                  <path
                                    d="M15.3701,37.044 L6.0001,27.673 L6.7071,26.966 C7.8791,25.795 9.7781,25.795 10.9491,26.966 L15.3701,31.387 L35.8791,10.878 C37.0501,9.707 38.9501,9.707 40.1211,10.878 L40.8281,11.586 L15.3701,37.044 Z"
                                    fill="#E87722"
                                  ></path>
                                </g>
                              </svg>
                            </Link>
                            <Link
                              href="https://www.fwd.co.th/"
                              onMouseEnter={() => {
                                toggleHover(true, 'TH');
                              }}
                              onMouseLeave={() => {
                                toggleHover(false, 'TH');
                              }}
                              className={
                                isHover && activeCountry === 'TH'
                                  ? classes.listItemHovered
                                  : classes.listItem
                              }
                            >
                              Thailand
                            </Link>
                            <Link
                              href="https://www.fwd.com.vn/"
                              onMouseEnter={() => {
                                toggleHover(true, 'VT');
                              }}
                              onMouseLeave={() => {
                                toggleHover(false, 'VT');
                              }}
                              className={
                                isHover && activeCountry === 'VT'
                                  ? classes.listItemHovered
                                  : classes.listItem
                              }
                            >
                              Vietnam
                            </Link>
                          </Select>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="nxtg-right-content">
            <div className="nxtg-button-container nxtg-popover-wrapper">
              <a href="#" className="nxtg-primary-button">
                Login
              </a>
              <div className="nxtg-popover-content">
                <ul>
                  <li>
                    <a href="https://portal.fwd.com.ph/CustomerPortal/Account/UserLogin.aspx?">
                      <span>
                        <svg
                          focusable="false"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <g fill-rule="evenodd">
                            <path d="m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"></path>
                            <path
                              d="m15.5292667 5.91913333-.472.47133334 8.39 8.38933333h-19.44733337v2.6666667h19.44866667l-8.3906667 8.3913333.4713334.4706667c.7806666.7813333 2.0473333.7813333 2.828 0l10.1946666-10.1946667-10.1946666-10.19466667c-.7813334-.78066666-2.0473334-.78066666-2.828 0"
                              transform="translate(8 8)"
                            ></path>
                          </g>
                        </svg>
                      </span>
                      <span>Customer</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://portal.fwd.com.ph/SalesPortalWeb">
                      <span>
                        <svg
                          focusable="false"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <g fill-rule="evenodd">
                            <path d="m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"></path>
                            <path
                              d="m15.5292667 5.91913333-.472.47133334 8.39 8.38933333h-19.44733337v2.6666667h19.44866667l-8.3906667 8.3913333.4713334.4706667c.7806666.7813333 2.0473333.7813333 2.828 0l10.1946666-10.1946667-10.1946666-10.19466667c-.7813334-.78066666-2.0473334-.78066666-2.828 0"
                              transform="translate(8 8)"
                            ></path>
                          </g>
                        </svg>
                      </span>
                      <span>Advisor</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="nxtg-contact-button-container nxtg-popover-wrapper">
              <a
                className="nxtg-contact-button"
                href="#"
                aria-label="Customer contact"
              >
                <svg viewBox="0 0 48 48">
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="48" height="48"></rect>
                    <path
                      d="M42.0001,30.0267 C42.0001,31.1217 41.1121,32.0087 40.0181,32.0087 L38.0351,32.0087 L38.0351,24.0347 L40.0191,24.0357 C41.1131,24.0357 42.0001,24.9227 42.0001,26.0177 L42.0001,30.0267 Z M10.0001,32.0087 L8.0181,32.0087 C6.9231,32.0087 6.0351,31.1217 6.0351,30.0267 L6.0351,26.0167 C6.0351,24.9227 6.9231,24.0347 8.0181,24.0347 L10.0001,24.0347 L10.0001,32.0087 Z M41.9491,20.3237 C41.0921,11.1807 33.3801,4.0007 24.0181,4.0007 C14.6551,4.0007 6.9431,11.1807 6.0861,20.3227 C3.7131,21.1307 2.0001,23.3747 2.0001,26.0167 L2.0001,30.0267 C2.0001,33.3497 4.6941,36.0447 8.0181,36.0447 L13.0351,36.0447 C13.5871,36.0447 14.0351,35.5957 14.0351,35.0447 L14.0351,20.9997 C14.0351,20.4467 13.5871,19.9997 13.0351,19.9997 L10.1981,19.9997 C11.1821,13.2447 16.9951,8.0357 24.0181,8.0357 C31.0401,8.0357 36.8541,13.2457 37.8371,19.9997 L35.0001,19.9997 C34.4471,19.9997 34.0001,20.4467 34.0001,20.9997 L34.0001,34.0267 C34.0001,37.3257 31.3251,40.0007 28.0261,40.0007 L28.0181,40.0007 L28.0181,39.0267 C28.0181,38.4737 27.5691,38.0267 27.0181,38.0267 L22.9961,38.0267 C21.3381,38.0267 19.9961,39.3697 19.9961,41.0267 L19.9961,43.0257 C19.9961,43.5787 20.4431,44.0257 20.9961,44.0257 L24.0061,44.0257 L24.0061,44.0357 L28.0261,44.0357 C32.8541,44.0357 36.8951,40.5987 37.8311,36.0447 L40.0181,36.0447 C43.3411,36.0447 46.0351,33.3497 46.0351,30.0267 L46.0351,26.0177 C46.0351,23.3757 44.3211,21.1307 41.9491,20.3237 L41.9491,20.3237 Z"
                      fill="#E87722"
                    ></path>
                  </g>
                </svg>
              </a>
              <div className="nxtg-popover-content nxtg-popover-content-right">
                <ul>
                  <li>
                    <a href="tel:+63288888388">
                      <span>
                        <svg
                          focusable="false"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <path
                            d="M10.5232,18.3972 C10.5472,18.4902 11.2982,21.2522 13.8022,24.3312 C15.0602,25.8942 19.5052,31.2222 24.1002,34.4972 C27.1852,36.7052 29.6592,37.4822 29.6842,37.4882 L29.8802,37.5602 C31.5142,38.2502 32.5532,37.9272 32.5972,37.9132 L32.7192,37.8722 C33.5822,37.6222 34.5062,36.9192 35.3052,36.2802 C36.2642,35.4922 37.0692,34.7382 37.7412,33.9982 C36.9552,33.1152 35.2532,31.5062 34.3992,30.8152 C34.2322,30.6812 34.0602,30.5382 33.8892,30.3962 C33.6082,30.1602 33.3382,29.9362 33.0792,29.7502 L33.0542,29.7752 C32.8622,29.9682 32.6312,30.2452 32.3792,30.5422 C31.2432,31.8842 30.4182,32.7862 29.3402,33.0942 C27.2532,33.7982 24.0042,31.1352 23.6412,30.8292 C21.5052,29.0652 18.4832,26.2622 17.0462,24.2012 C15.3162,21.7292 14.4262,20.0332 14.9172,18.5632 C15.2082,17.5882 16.1042,16.7622 17.4352,15.6202 C17.7362,15.3622 18.0162,15.1262 18.2092,14.9332 C18.2182,14.9232 18.2282,14.9142 18.2372,14.9052 C17.9592,14.5072 17.6072,14.0962 17.2652,13.6962 L17.1712,13.5862 C16.4842,12.7382 14.8922,11.0542 13.9762,10.2462 C13.2002,10.9282 12.4472,11.7362 11.7162,12.6672 C11.0792,13.4632 10.3932,14.3642 10.1292,15.2152 L10.1052,15.2992 C10.0242,15.5792 9.8082,16.6092 10.4312,18.1202 L10.5232,18.3972 Z M31.8562,41.9962 C30.9292,41.9962 29.7522,41.8322 28.4132,41.2812 C27.8202,41.0882 25.0812,40.1182 21.7752,37.7522 C16.7682,34.1832 12.0262,28.5032 10.6922,26.8482 C7.9032,23.4172 6.8962,20.2702 6.6852,19.5242 C5.7802,17.2552 5.9512,15.4542 6.1922,14.4502 L6.1922,14.4232 L6.2722,14.1492 C6.7282,12.5812 7.7042,11.2782 8.5822,10.1822 C9.6012,8.8842 10.6882,7.7562 11.8002,6.8432 C12.9802,5.8982 14.0832,5.9172 14.8032,6.0972 L15.1242,6.2072 C16.8502,6.9682 20.2482,11.0292 20.2802,11.0702 C20.7612,11.6302 21.2812,12.2362 21.7212,12.9202 C22.1392,13.4572 22.3892,14.0402 22.4662,14.6552 C22.7382,16.1872 21.6482,17.1942 21.1832,17.6242 L21.0362,17.7622 C20.7872,18.0112 20.4292,18.3222 20.0402,18.6562 C19.7352,18.9182 19.2412,19.3412 18.9202,19.6622 C19.0992,20.0362 19.4802,20.7022 20.2942,21.8652 C21.3052,23.3142 23.6662,25.6622 26.2022,27.7572 C26.7522,28.2192 27.7322,28.8222 28.3202,29.0862 C28.6372,28.7722 29.0662,28.2662 29.3272,27.9562 C29.6612,27.5642 29.9722,27.2012 30.2252,26.9482 L30.3572,26.8102 C30.8012,26.3392 31.8452,25.2362 33.4512,25.5382 L33.6322,25.5812 C34.1372,25.7262 34.5552,25.9652 34.8912,26.1562 C35.5262,26.5522 35.9972,26.9442 36.4532,27.3242 C36.6032,27.4502 36.7542,27.5752 36.9072,27.6982 C36.9552,27.7372 41.0212,31.1392 41.7792,32.8632 L41.8972,33.2182 C42.2602,34.7912 41.4302,35.8272 41.1572,36.1672 C40.2302,37.2582 39.1522,38.2962 37.8242,39.3872 C36.7172,40.2732 35.4312,41.2352 33.8892,41.6972 C33.5972,41.7962 32.8792,41.9962 31.8562,41.9962 L31.8562,41.9962 Z"
                            fill=""
                          ></path>
                        </svg>
                      </span>
                      <span>Call</span>
                    </a>
                  </li>
                  <li>
                    <a id="chatBox" href="#" onClick={openChatHead}>
                      {/* onClick={window['chatNowButtonToggle']()} */}
                      <span>
                        <svg
                          focusable="false"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <g>
                            <path
                              d="M24.1224,5.9997 C34.1194,5.9997 42.2244,14.1037 42.2244,24.1017 L42.2244,24.1017 L42.2244,24.1127 C42.2244,34.1167 34.1144,42.2257 24.1114,42.2257 L24.1114,42.2257 L9.0004,42.2257 C7.3434,42.2257 6.0004,40.8827 6.0004,39.2257 L6.0004,39.2257 L6.0004,24.1127 C6.0004,14.1097 14.1094,5.9997 24.1134,5.9997 L24.1134,5.9997 Z M24.1224,9.9997 C16.3314,9.9997 10.0004,16.3307 10.0004,24.1127 L10.0004,24.1127 L10.0004,38.2257 L24.1114,38.2257 C31.8934,38.2257 38.2244,31.8947 38.2244,24.1127 C38.2244,16.3257 31.8984,9.9997 24.1224,9.9997 L24.1224,9.9997 Z M24.0874,21.8447 C25.4224,21.8447 26.4684,22.8907 26.4684,24.2257 C26.4684,25.5607 25.4224,26.6067 24.0874,26.6067 C22.7524,26.6067 21.7064,25.5607 21.7064,24.2257 C21.7064,22.9137 22.7744,21.8447 24.0874,21.8447 Z M16.4684,21.8447 C17.8024,21.8447 18.8484,22.8907 18.8484,24.2257 C18.8484,25.5607 17.8024,26.6067 16.4684,26.6067 C15.1334,26.6067 14.0864,25.5607 14.0864,24.2257 C14.0864,22.9137 15.1554,21.8447 16.4684,21.8447 Z M31.7074,21.8447 C33.0414,21.8447 34.0884,22.8907 34.0884,24.2257 C34.0884,25.5607 33.0414,26.6067 31.7074,26.6067 C30.3944,26.6067 29.3254,25.5387 29.3254,24.2257 C29.3254,22.9137 30.3944,21.8447 31.7074,21.8447 Z"
                              id="Chat"
                              fill="#333333"
                            ></path>
                          </g>
                        </svg>
                      </span>
                      <span>Live chat</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
      <div className="nxtg-left-content">
        <div className="nxtg-header-logo">
          <a
            href="https://www.fwd.com.ph/"
            type="svg+xml"
            aria-label="FWD Logo"
          >
            <svg
              viewBox="0 0 105 36"
              width="100%"
              height="100%"
              focusable="false"
            >
              <path
                d=" m85.0647368 16.8813014c.2339474.2394642.3647369.553646.3647369.8886508 0
              .332555-.1307895.6510239-.3647369.8898756l-6.2158772
              6.1452248c-.2468421.2388517-.5728947.3680766-.9001754.3680766-.1633333
              0-.3291228-.0275598-.4881579-.0967656-.472807-.1947559-.7810526-.6516363-.7810526-1.1593492v-12.2922871c0-.5107751.3082456-.9664306.7810526-1.1648613.4771053-.1929186
              1.0229825-.0839043 1.3883333.2737608z"
                fill="#e87722"
              />
              <path
                d="m46.1005263.88926316c-.7386842.59467942-1.2642982 1.29898564-1.5903509 2.12026794-.3242105.81699522-.6821929 2.00390431-1.1009649 3.56991388l-.3278947 1.22855502-4.0403509 15.8530144-4.708421-20.27789478c-.4003509-1.93776077-1.4890351-3.13385646-4.1846492-3.13385646h-28.77491224c-1.32263158 0-1.36929825 1.39330143-1.37298246 1.4049378v32.86047844s.02210526.6987943.6981579.6987943h2.67350877c1.92008772 0 4.37438596-1.2346794 4.37438596-4.6398469v-10.0103349h10.07631577c3.8432456 0 4.7790351-2.7363828 4.7790351-4.2925933v-.5781436c0-.552421-.1872807-.8874258-.8553509-.8874258h-13.99999997v-8.29182776h19.79280697l5.9727193 22.93833496c.1829825.6865454 1.2280702 4.3164784 1.2280702 4.3164784.402193 1.2726508.3579825 1.4576077 1.4448246 1.4576077h2.4199123c2.9731579 0 3.9998245-1.8269091 4.5248245-3.1160957.2640351-.6987943.4513158-1.0062392.8756141-2.5820479l5.2659649-19.77385641 5.5699123 19.67525361c.1811403.6871579 1.1531578 4.331177 1.1531578 4.331177.400965 1.2683636.3604386 1.4631196 1.4478948 1.4631196h2.4174561c2.975 0 4.0035088-1.8287464 4.5291228-3.1258947.2572807-.6987943.5170176-1.3669665.943772-2.9391005l5.4753508-22.62537798h16.9547369c1.4577193 0 2.6311403.12677512 3.6878947.44585646 1.3668421.40972249 2.5826316 1.43188517 3.5970176 3.03157892.9824561 1.5684594 1.5442982 4.3146412 1.5700877 7.725933-.0018421 3.8448996-1.155 7.2580288-3.2967544 9.1026986-.4771053.429933-1.0371053.7631005-1.7008772 1.0062392-.6766667.2486508-1.330614.4054354-1.9507895.4679043-.6680701.0698182-1.5522807.2045551-2.7152631.2143541h-.016579l-3.6977193.0061244h-5.3120175l-.0264035-.0061244c-1.1488597 0-1.1850877.6651101-1.1850877.9517321v1.3755406c0 2.0014546 1.6566666 4.3023924 4.9835087 4.3023924h.1148246l6.4535088-.0036747c1.6425438-.0165358 3.116228-.1365741 4.4370175-.3613397 1.3281579-.2308899 2.5783333-.6106028 3.7419298-1.1624115 1.1635965-.5444593 2.2381579-1.2671387 3.2163158-2.1588516 1.236053-1.1562871 2.244912-2.4632345 3.031491-3.9245168.777369-1.4618947 1.350877-3.0903732 1.711316-4.8829856.340175-1.6927847.509035-2.8974546.509035-4.9050335v-.0422584c-.056491-6.5010526-1.982719-11.1225263-5.8210525-14.34886123-1.4718421-1.26713875-3.1303509-2.13435406-4.9540351-2.58817225-1.6947368-.42564593-3.6958772-.63448803-5.9825439-.63448803h-20.5419298c-1.1273684.0122488-2.8165789.59222966-3.4662281 3.23858373l-4.4566666 20.14744498-4.7366667-15.79850718v.01163636l-.3180702-1.1642488c-.4568421-1.68421053-.8252631-2.89316747-1.0991228-3.62380862-.2757017-.72880382-.7607894-1.40371292-1.4736842-2.02778947-.7024561-.61856459-1.6965789-.92784689-2.9731579-.92784689-1.2661403 0-2.258421.29519617-2.9909649.88926316"
                fill="#183028"
              />
            </svg>
          </a>
        </div>
        <div className="nxtg-header-links-wrapper">
          <div className="nxtg-header-dialoag-wrapper">
            <div className="nxtg-header-links-primary-secondary">
              <div className="nxtg-primary-link">
                <ul>
                  {/* Products */}
                  <li>
                    <a href="https://www.fwd.com.ph/products/">
                      <span className="nxtg-primary-link-icon">
                        <svg
                          focusable="false"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <g>
                            <path d="m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"></path>
                            <path
                              d="m15.9982667 2.66653333.1746666.00733334c.1776-.01066667.2818134.01365333.3805654.04770133l.0741013.02696533-.01.028c1.2122182.2808 4.0252641 1.21195637 11.4090674 3.81941035l.4149326.14658965.726.25666667.1406667.75733333c.016.088.228 1.27466667.2086666 3.08133337-.0135333 1.3552666-1.6069007 2.0452089-2.6079757 1.1942314l-.1013576-.0935648c.0793333-1.264.0306667-2.30599997-.0293333-2.95466663-4.5666667-1.608-9.4646667-3.28133334-10.6953334-3.61266667-1.232.332-6.1353333 2.00666667-10.7033333 3.61533333-.28933333 2.84199997-.466 12.91533337 10.7033333 17.54399997 1.1126667-.4613333 2.1473334-.994 3.0966667-1.59.753125-.4725 1.7130859-.4235156 2.3827515.1376148l.1299152.1190519.7186666.718c0 .0046667-.0006666.006-.0006666.01-1.5606154 1.2344615-3.3831006 2.2814675-5.4197397 3.1148002l-.5135937.2038665-.2313333.0893333h-.3206667l-.2366666-.0893333c-15.36546003-5.91426-12.91139523-21.02708523-12.83296215-21.47817636l.00162878-.00915701.14066667-.75733333.726-.25666667c7.5541091-2.66989091 10.4824621-3.64448529 11.7549887-3.94972439l.0690113-.01627561-.01-.028c.1002667-.0368.1890133-.06976.3341653-.07566933l.1205014.00100267zm8.9835333 9.87906667v3.9993333h4v.6666667c0 1.0544545-.8157893 1.9181736-1.8507256 1.9945148l-.1492744.0054852h-2v2.0006667c0 1.0544545-.8157893 1.9181735-1.8507256 1.9945148l-.1492744.0054852h-.6666667v-4.0006667h-4v-.6666667c0-1.0538181.8157893-1.9181157 1.8507256-1.9945109l.1492744-.0054891h2v-1.9993333c0-1.0544545.8157893-1.9181736 1.8507256-1.9945148l.1492744-.0054852zm-9.3335333 2.1191333v.6666667c0 1.104-.8953334 2-2 2h-4.70200003c-.368 0-.66666667-.298-.66666667-.6666667v-1.3333333c0-.3686667.29866667-.6666667.66666667-.6666667zm4.0002-4v.6666667c0 1.0538182-.8157893 1.9181157-1.8507256 1.9945109l-.1492744.0054891h-8.89933337c-.33454545 0-.61179063-.246281-.65943401-.5680441l-.00723265-.0986226v-1.3333333c0-.3351515.24683195-.6119008.56819434-.659449l.09847232-.0072177z"
                              transform="translate(8 8)"
                            ></path>
                          </g>
                        </svg>
                      </span>
                      Products
                    </a>
                  </li>

                  {/* Claims */}
                  <li>
                    <a href="https://www.fwd.com.ph/claims/">
                      <span className="nxtg-primary-link-icon">
                        <svg
                          focusable="false"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <g>
                            <path d="m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"></path>
                            <path
                              d="m18.6689333 20.6287333v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.962v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0 4v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.37333333.3-.66666667.6666667-.66666667zm-6.6686666 3.99999997v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0 4v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.37333333.3-.66666667.66666667-.66666667zm14.6666666 1.33333337h-4v-2.00000003c0-1.10733334.9-2 2-2 1.1066667 0 2 .89266666 2 2zm-6.6666666-2.00000003v18.00000003h-14.6666667v-18.00000003c0-1.10733334.9-2 2-2h13.12c-.2866667.60666666-.4533333 1.28-.4533333 2zm4.6666666-4.66666667h-17.3333333c-2.57333333 0-4.66666667 2.09266667-4.66666667 4.66666667v20.66666663h19.99999997v-16h5.3333334c.7393333 0 1.3333333-.6 1.3333333-1.3333333v-3.33333333c0-2.574-2.094-4.66666667-4.6666667-4.66666667z"
                              transform="translate(8 8)"
                            ></path>
                          </g>
                        </svg>
                      </span>
                      Claims
                    </a>
                  </li>
                  {/* Support */}
                  <li>
                    <a href="https://www.fwd.com.ph/support">
                      <span className="nxtg-primary-link-icon">
                        <svg
                          focusable="false"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <g>
                            <path d="m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"></path>
                            <path
                              d="m18.6689333 20.6287333v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.962v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0 4v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.37333333.3-.66666667.6666667-.66666667zm-6.6686666 3.99999997v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0 4v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.37333333.3-.66666667.66666667-.66666667zm14.6666666 1.33333337h-4v-2.00000003c0-1.10733334.9-2 2-2 1.1066667 0 2 .89266666 2 2zm-6.6666666-2.00000003v18.00000003h-14.6666667v-18.00000003c0-1.10733334.9-2 2-2h13.12c-.2866667.60666666-.4533333 1.28-.4533333 2zm4.6666666-4.66666667h-17.3333333c-2.57333333 0-4.66666667 2.09266667-4.66666667 4.66666667v20.66666663h19.99999997v-16h5.3333334c.7393333 0 1.3333333-.6 1.3333333-1.3333333v-3.33333333c0-2.574-2.094-4.66666667-4.6666667-4.66666667z"
                              transform="translate(8 8)"
                            ></path>
                          </g>
                        </svg>
                      </span>
                      Support
                    </a>
                  </li>
                  {/* Blog */}
                  <li>
                    <a href="https://www.fwd.com.ph/blog">
                      <span className="nxtg-primary-link-icon">
                        <svg
                          focusable="false"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <g>
                            <path d="m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"></path>
                            <path
                              d="m18.6689333 20.6287333v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.962v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0 4v.6666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.3733333.3-.6666667.6666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.8953333 2-2 2h-2.6666666c-.3666667 0-.6666667-.3006667-.6666667-.6666667v-1.3333333c0-.37333333.3-.66666667.6666667-.66666667zm-6.6686666 3.99999997v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0 4v.6666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.3733333.3-.6666667.66666667-.6666667zm0-7.99999997v.66666667c0 1.1046667-.896 2-2 2h-2.6666667c-.36666667 0-.66666667-.3006667-.66666667-.6666667v-1.3333333c0-.37333333.3-.66666667.66666667-.66666667zm14.6666666 1.33333337h-4v-2.00000003c0-1.10733334.9-2 2-2 1.1066667 0 2 .89266666 2 2zm-6.6666666-2.00000003v18.00000003h-14.6666667v-18.00000003c0-1.10733334.9-2 2-2h13.12c-.2866667.60666666-.4533333 1.28-.4533333 2zm4.6666666-4.66666667h-17.3333333c-2.57333333 0-4.66666667 2.09266667-4.66666667 4.66666667v20.66666663h19.99999997v-16h5.3333334c.7393333 0 1.3333333-.6 1.3333333-1.3333333v-3.33333333c0-2.574-2.094-4.66666667-4.6666667-4.66666667z"
                              transform="translate(8 8)"
                            ></path>
                          </g>
                        </svg>
                      </span>
                      Blog
                    </a>
                  </li>
                </ul>
              </div>
              <div className="nxtg-secondary-link">
                <ul>
                  <li>
                    <a href="https://www.fwd.com.ph/about/">About us</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="nxtg-header-country-wrapper-mobile">
              <div className="nxtg-country-wrapper">
                <span className="nxtg-country-label">Visit FWD</span>
                <div className="nxtg-dropdown-wrapper nxtg-dropmenu-country">
                  <div className="nxtg-country-dropmenu-container">
                    <span>Philippines</span>
                    <svg
                      focusable="false"
                      viewBox="0 0 48 48"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <path
                          d="M12.5855,21.2426 L23.1715,10.6576 L33.7575,21.2426 L34.4645,20.5356 C35.6365,19.3646 35.6365,17.4646 34.4645,16.2936 L23.1715,4.9996 L11.8785,16.2936 C10.7065,17.4646 10.7065,19.3646 11.8785,20.5356 L12.5855,21.2426 Z M34.4645,27.1216 C35.6365,28.2926 35.6365,30.1926 34.4645,31.3636 L23.1715,42.6576 L11.8785,31.3636 C10.7065,30.1926 10.7065,28.2926 11.8785,27.1216 L12.5855,26.4146 L23.1715,36.9996 L33.7575,26.4146 L34.4645,27.1216 Z"
                          fill="#E87722"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <div className="nxtg-dropdown-content">
                    <ul>
                      <li>
                        <a href="https://www.fwd.com/">
                          <span>FWD Group</span>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.fwd.com.hk/">
                          <span>Hong Kong</span>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.fwd.co.id/">
                          <span>Indonesia</span>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.fwdfujilife.co.jp/">
                          <span>Japan</span>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.fwd.com.ph/"
                          className="nxtg-dropdown-active"
                        >
                          <span>Philippines</span>
                          <span>
                            <svg
                              focusable="false"
                              viewBox="0 0 48 48"
                              aria-hidden="true"
                              role="presentation"
                            >
                              <g
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                              >
                                <path
                                  d="M15.3701,37.044 L6.0001,27.673 L6.7071,26.966 C7.8791,25.795 9.7781,25.795 10.9491,26.966 L15.3701,31.387 L35.8791,10.878 C37.0501,9.707 38.9501,9.707 40.1211,10.878 L40.8281,11.586 L15.3701,37.044 Z"
                                  fill="#E87722"
                                ></path>
                              </g>
                            </svg>
                            <svg
                              focusable="false"
                              viewBox="0 0 48 48"
                              aria-hidden="true"
                              role="presentation"
                            >
                              <g
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                              >
                                <path
                                  d="M12.5855,21.2426 L23.1715,10.6576 L33.7575,21.2426 L34.4645,20.5356 C35.6365,19.3646 35.6365,17.4646 34.4645,16.2936 L23.1715,4.9996 L11.8785,16.2936 C10.7065,17.4646 10.7065,19.3646 11.8785,20.5356 L12.5855,21.2426 Z M34.4645,27.1216 C35.6365,28.2926 35.6365,30.1926 34.4645,31.3636 L23.1715,42.6576 L11.8785,31.3636 C10.7065,30.1926 10.7065,28.2926 11.8785,27.1216 L12.5855,26.4146 L23.1715,36.9996 L33.7575,26.4146 L34.4645,27.1216 Z"
                                  fill="#E87722"
                                ></path>
                              </g>
                            </svg>
                          </span>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.fwd.co.th/">
                          <span>Thailand</span>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.fwd.com.vn/">
                          <span>Vietnam</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="nxtg-right-content">
        <div className="nxtg-button-container nxtg-popover-wrapper">
          <a href="#" className="nxtg-primary-button">
            Login
          </a>
          <div className="nxtg-popover-content">
            <ul>
              <li>
                <a href="https://portal.fwd.com.ph/CustomerPortal/Account/UserLogin.aspx?">
                  <span>
                    <svg
                      focusable="false"
                      viewBox="0 0 48 48"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <g fill-rule="evenodd">
                        <path d="m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"></path>
                        <path
                          d="m15.5292667 5.91913333-.472.47133334 8.39 8.38933333h-19.44733337v2.6666667h19.44866667l-8.3906667 8.3913333.4713334.4706667c.7806666.7813333 2.0473333.7813333 2.828 0l10.1946666-10.1946667-10.1946666-10.19466667c-.7813334-.78066666-2.0473334-.78066666-2.828 0"
                          transform="translate(8 8)"
                        ></path>
                      </g>
                    </svg>
                  </span>
                  <span>Customer</span>
                </a>
              </li>
              <li>
                <a href="https://portal.fwd.com.ph/SalesPortalWeb">
                  <span>
                    <svg
                      focusable="false"
                      viewBox="0 0 48 48"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <g fill-rule="evenodd">
                        <path d="m24.0007301 0c13.2546433 0 23.9995899 10.7457668 23.9995899 24.0004101s-10.7449466 24.0012302-23.9995899 24.0012302c-13.2554635 0-24.0004101-10.7465869-24.0004101-24.0012302s10.7449466-24.0004101 24.0004101-24.0004101zm0 2.5c-11.8744552 0-21.5004101 9.6261822-21.5004101 21.5004101 0 11.8744108 9.6261378 21.5012302 21.5004101 21.5012302 11.8735657 0 21.4995899-9.6269331 21.4995899-21.5012302 0-11.8741143-9.6258413-21.5004101-21.4995899-21.5004101z"></path>
                        <path
                          d="m15.5292667 5.91913333-.472.47133334 8.39 8.38933333h-19.44733337v2.6666667h19.44866667l-8.3906667 8.3913333.4713334.4706667c.7806666.7813333 2.0473333.7813333 2.828 0l10.1946666-10.1946667-10.1946666-10.19466667c-.7813334-.78066666-2.0473334-.78066666-2.828 0"
                          transform="translate(8 8)"
                        ></path>
                      </g>
                    </svg>
                  </span>
                  <span>Advisor</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="nxtg-contact-button-container nxtg-popover-wrapper">
          <a
            className="nxtg-contact-button"
            href="#"
            aria-label="Customer contact"
          >
            <svg viewBox="0 0 48 48">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="48" height="48"></rect>
                <path
                  d="M42.0001,30.0267 C42.0001,31.1217 41.1121,32.0087 40.0181,32.0087 L38.0351,32.0087 L38.0351,24.0347 L40.0191,24.0357 C41.1131,24.0357 42.0001,24.9227 42.0001,26.0177 L42.0001,30.0267 Z M10.0001,32.0087 L8.0181,32.0087 C6.9231,32.0087 6.0351,31.1217 6.0351,30.0267 L6.0351,26.0167 C6.0351,24.9227 6.9231,24.0347 8.0181,24.0347 L10.0001,24.0347 L10.0001,32.0087 Z M41.9491,20.3237 C41.0921,11.1807 33.3801,4.0007 24.0181,4.0007 C14.6551,4.0007 6.9431,11.1807 6.0861,20.3227 C3.7131,21.1307 2.0001,23.3747 2.0001,26.0167 L2.0001,30.0267 C2.0001,33.3497 4.6941,36.0447 8.0181,36.0447 L13.0351,36.0447 C13.5871,36.0447 14.0351,35.5957 14.0351,35.0447 L14.0351,20.9997 C14.0351,20.4467 13.5871,19.9997 13.0351,19.9997 L10.1981,19.9997 C11.1821,13.2447 16.9951,8.0357 24.0181,8.0357 C31.0401,8.0357 36.8541,13.2457 37.8371,19.9997 L35.0001,19.9997 C34.4471,19.9997 34.0001,20.4467 34.0001,20.9997 L34.0001,34.0267 C34.0001,37.3257 31.3251,40.0007 28.0261,40.0007 L28.0181,40.0007 L28.0181,39.0267 C28.0181,38.4737 27.5691,38.0267 27.0181,38.0267 L22.9961,38.0267 C21.3381,38.0267 19.9961,39.3697 19.9961,41.0267 L19.9961,43.0257 C19.9961,43.5787 20.4431,44.0257 20.9961,44.0257 L24.0061,44.0257 L24.0061,44.0357 L28.0261,44.0357 C32.8541,44.0357 36.8951,40.5987 37.8311,36.0447 L40.0181,36.0447 C43.3411,36.0447 46.0351,33.3497 46.0351,30.0267 L46.0351,26.0177 C46.0351,23.3757 44.3211,21.1307 41.9491,20.3237 L41.9491,20.3237 Z"
                  fill="#E87722"
                ></path>
              </g>
            </svg>
          </a>
          <div className="nxtg-popover-content nxtg-popover-content-right">
            <ul>
              <li>
                <a href="tel:+63288888388">
                  <span>
                    <svg
                      focusable="false"
                      viewBox="0 0 48 48"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <path
                        d="M10.5232,18.3972 C10.5472,18.4902 11.2982,21.2522 13.8022,24.3312 C15.0602,25.8942 19.5052,31.2222 24.1002,34.4972 C27.1852,36.7052 29.6592,37.4822 29.6842,37.4882 L29.8802,37.5602 C31.5142,38.2502 32.5532,37.9272 32.5972,37.9132 L32.7192,37.8722 C33.5822,37.6222 34.5062,36.9192 35.3052,36.2802 C36.2642,35.4922 37.0692,34.7382 37.7412,33.9982 C36.9552,33.1152 35.2532,31.5062 34.3992,30.8152 C34.2322,30.6812 34.0602,30.5382 33.8892,30.3962 C33.6082,30.1602 33.3382,29.9362 33.0792,29.7502 L33.0542,29.7752 C32.8622,29.9682 32.6312,30.2452 32.3792,30.5422 C31.2432,31.8842 30.4182,32.7862 29.3402,33.0942 C27.2532,33.7982 24.0042,31.1352 23.6412,30.8292 C21.5052,29.0652 18.4832,26.2622 17.0462,24.2012 C15.3162,21.7292 14.4262,20.0332 14.9172,18.5632 C15.2082,17.5882 16.1042,16.7622 17.4352,15.6202 C17.7362,15.3622 18.0162,15.1262 18.2092,14.9332 C18.2182,14.9232 18.2282,14.9142 18.2372,14.9052 C17.9592,14.5072 17.6072,14.0962 17.2652,13.6962 L17.1712,13.5862 C16.4842,12.7382 14.8922,11.0542 13.9762,10.2462 C13.2002,10.9282 12.4472,11.7362 11.7162,12.6672 C11.0792,13.4632 10.3932,14.3642 10.1292,15.2152 L10.1052,15.2992 C10.0242,15.5792 9.8082,16.6092 10.4312,18.1202 L10.5232,18.3972 Z M31.8562,41.9962 C30.9292,41.9962 29.7522,41.8322 28.4132,41.2812 C27.8202,41.0882 25.0812,40.1182 21.7752,37.7522 C16.7682,34.1832 12.0262,28.5032 10.6922,26.8482 C7.9032,23.4172 6.8962,20.2702 6.6852,19.5242 C5.7802,17.2552 5.9512,15.4542 6.1922,14.4502 L6.1922,14.4232 L6.2722,14.1492 C6.7282,12.5812 7.7042,11.2782 8.5822,10.1822 C9.6012,8.8842 10.6882,7.7562 11.8002,6.8432 C12.9802,5.8982 14.0832,5.9172 14.8032,6.0972 L15.1242,6.2072 C16.8502,6.9682 20.2482,11.0292 20.2802,11.0702 C20.7612,11.6302 21.2812,12.2362 21.7212,12.9202 C22.1392,13.4572 22.3892,14.0402 22.4662,14.6552 C22.7382,16.1872 21.6482,17.1942 21.1832,17.6242 L21.0362,17.7622 C20.7872,18.0112 20.4292,18.3222 20.0402,18.6562 C19.7352,18.9182 19.2412,19.3412 18.9202,19.6622 C19.0992,20.0362 19.4802,20.7022 20.2942,21.8652 C21.3052,23.3142 23.6662,25.6622 26.2022,27.7572 C26.7522,28.2192 27.7322,28.8222 28.3202,29.0862 C28.6372,28.7722 29.0662,28.2662 29.3272,27.9562 C29.6612,27.5642 29.9722,27.2012 30.2252,26.9482 L30.3572,26.8102 C30.8012,26.3392 31.8452,25.2362 33.4512,25.5382 L33.6322,25.5812 C34.1372,25.7262 34.5552,25.9652 34.8912,26.1562 C35.5262,26.5522 35.9972,26.9442 36.4532,27.3242 C36.6032,27.4502 36.7542,27.5752 36.9072,27.6982 C36.9552,27.7372 41.0212,31.1392 41.7792,32.8632 L41.8972,33.2182 C42.2602,34.7912 41.4302,35.8272 41.1572,36.1672 C40.2302,37.2582 39.1522,38.2962 37.8242,39.3872 C36.7172,40.2732 35.4312,41.2352 33.8892,41.6972 C33.5972,41.7962 32.8792,41.9962 31.8562,41.9962 L31.8562,41.9962 Z"
                        fill=""
                      ></path>
                    </svg>
                  </span>
                  <span>Call</span>
                </a>
              </li>
              <li>
                <a id="chatBox" href="#" onClick={openChatHead}>
                  {/* onClick={window['chatNowButtonToggle']()} */}
                  <span>
                    <svg
                      focusable="false"
                      viewBox="0 0 48 48"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <g>
                        <path
                          d="M24.1224,5.9997 C34.1194,5.9997 42.2244,14.1037 42.2244,24.1017 L42.2244,24.1017 L42.2244,24.1127 C42.2244,34.1167 34.1144,42.2257 24.1114,42.2257 L24.1114,42.2257 L9.0004,42.2257 C7.3434,42.2257 6.0004,40.8827 6.0004,39.2257 L6.0004,39.2257 L6.0004,24.1127 C6.0004,14.1097 14.1094,5.9997 24.1134,5.9997 L24.1134,5.9997 Z M24.1224,9.9997 C16.3314,9.9997 10.0004,16.3307 10.0004,24.1127 L10.0004,24.1127 L10.0004,38.2257 L24.1114,38.2257 C31.8934,38.2257 38.2244,31.8947 38.2244,24.1127 C38.2244,16.3257 31.8984,9.9997 24.1224,9.9997 L24.1224,9.9997 Z M24.0874,21.8447 C25.4224,21.8447 26.4684,22.8907 26.4684,24.2257 C26.4684,25.5607 25.4224,26.6067 24.0874,26.6067 C22.7524,26.6067 21.7064,25.5607 21.7064,24.2257 C21.7064,22.9137 22.7744,21.8447 24.0874,21.8447 Z M16.4684,21.8447 C17.8024,21.8447 18.8484,22.8907 18.8484,24.2257 C18.8484,25.5607 17.8024,26.6067 16.4684,26.6067 C15.1334,26.6067 14.0864,25.5607 14.0864,24.2257 C14.0864,22.9137 15.1554,21.8447 16.4684,21.8447 Z M31.7074,21.8447 C33.0414,21.8447 34.0884,22.8907 34.0884,24.2257 C34.0884,25.5607 33.0414,26.6067 31.7074,26.6067 C30.3944,26.6067 29.3254,25.5387 29.3254,24.2257 C29.3254,22.9137 30.3944,21.8447 31.7074,21.8447 Z"
                          id="Chat"
                          fill="#333333"
                        ></path>
                      </g>
                    </svg>
                  </span>
                  <span>Live chat</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* <Hidden smDown>
        <div className={classes.header}>
          <div className={classes.left_session}>
            <Link
              href="https://www.fwd.com.ph/en/?_ga=2.6424818.1783023463.1598238668-2088042553.1598238668"
              target="_blank"
              className={classes.session}
            >
              INDIVIDUAL
            </Link>
            <span>|</span>
            <Link
              href="https://www.fwd.com.ph/en/corporate-care/"
              target="_blank"
              className={classes.session}
            >
              CORPORATE
            </Link>
          </div>

          <div className={classes.right_session}>
            <Link
              href="https://www.fwd.com.ph/en/about/"
              target="_blank"
              className={classes.session}
            >
              ABOUT US
            </Link>
            <Link
              href="https://www.fwd.com.ph/en/contact-us/"
              target="_blank"
              className={classes.session}
            >
              CONTACT US
            </Link>
          </div>
        </div>

        <div className={classes.nav_header}>
          <img
            src={logo}
            alt={logo}
            className={clsx(classes.logo, classes.left_session)}
          />
          <div className={classes.right_session}>
            {options.map(el => (
              <Link
                href={el.path}
                key={el.label}
                className={classes.header_optional}
                target="_blank"
              >
                {el.label}
              </Link>
            ))}
          </div>
        </div>
      </Hidden>
      <Hidden mdUp>
        <div className={classes.menuHeader}>
          <img src={logoMobile} alt={logoMobile} className={classes.logo} />
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            className={classes.nav_header}
            onClick={() => {
              handleDrawer(true);
            }}
          >
            <MenuIcon />
          </IconButton>
          <Drawer
            anchor={'left'}
            open={isOpenMenu}
            onClose={() => {
              handleDrawer(false);
            }}
            classes={{ paper: classes.paper }}
          >
            <div className={classes.drawerHeader}>
              <span className={classes.linkHeader}>
                <Link
                  href="https://www.fwd.com.ph/en/?_ga=2.6424818.1783023463.1598238668-2088042553.1598238668"
                  className={classes.header_option}
                >
                  INDIVIDUAL
                </Link>
                <span className={classes.header_option}>|</span>
                <Link
                  href="https://www.fwd.com.ph/en/corporate-care/"
                  className={classes.header_option}
                >
                  CORPORATE
                </Link>
              </span>
              <IconButton
                onClick={() => {
                  handleDrawer(false);
                }}
              >
                <CloseIcon className={classes.menuIcon} />
              </IconButton>
            </div>
            {list()}
          </Drawer>
        </div>
      </Hidden> */}
    </div>
  );
}
